module.exports = __webpack_public_path__ + "static/media/sidemenu-logout.c62e491e.svg";